import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UcrFormsModule } from '../forms/ucrforms.module';
import { SharedModule } from '../shared/shared.module';
import { FilterStateService } from './table-filter/filter-state.service';
import { TableFilterComponent } from './table-filter/table-filter.component';
import { TableMergeService } from './table-merge.service';
import { TableComponent } from './table.component';
import { TableHeaderComponent } from './table-header/table-header.component';
import { TableCellComponent } from './table-cell/table-cell.component';
import { TableActionComponent } from './table-action/table-action.component';

@NgModule({
    declarations: [
        TableComponent,
        TableFilterComponent,
        TableHeaderComponent,
        TableCellComponent,
        TableActionComponent
    ],
    imports: [
        CommonModule,
        UcrFormsModule,
        MatIconModule,
        MatProgressBarModule,
        MatTooltipModule,
        SharedModule,
        MatTableModule,
        MatSortModule,
        MatButtonModule,
        MatPaginatorModule,
        MatProgressSpinnerModule
    ],
    exports: [TableComponent, TableFilterComponent],
    providers: [FilterStateService, TableMergeService]
})
export class TablesModule {}
